import { Link } from '@tanstack/react-router';
import { Eye } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { PcmpMarketingQueueItem, PcmpMarketingTab } from '../../types/pcmpMarketing.types';
import { PcmpConfirmDisbursementButton } from '../PcmpDisbursementAck/PcmpConfirmDisbursementButton';
import { PcmpHoldActionButtons } from '../PcmpHoldActions/PcmpHoldActionButtons';
import { PcmpMarketingActionButtons } from '../PcmpMarketingActions/PcmpMarketingActionButtons';

interface PcmpMarketingRowActionsProps {
  item: PcmpMarketingQueueItem;
  /** The list the row is on; a batch's drill-down lists as All Proposals. */
  tab: PcmpMarketingTab;
}

/** What a Proposals page row offers: the chain's step, hold or release, and the proposal. */
export function PcmpMarketingRowActions({ item, tab }: PcmpMarketingRowActionsProps) {
  const { action, misNotVerified } = item;
  // The row carries no explanation capability: offer it on its own tab and
  // let the API answer who may submit.
  const canExplain =
    tab === 'MIS_NOT_VERIFIED' && misNotVerified !== null && !misNotVerified.explanation;
  return (
    <>
      <PcmpMarketingActionButtons
        proposalId={item.proposalId}
        refNo={item.refNo}
        approve={action ? { kind: action.kind, levelNo: action.levelNo } : null}
        canReject={action !== null && action.kind !== 'ENDORSE'}
        explanation={canExplain ? { misReasonLabel: misNotVerified.reasonLabel } : null}
        canDisburse={item.canMktDisburse}
        className="flex-nowrap"
      />
      <PcmpConfirmDisbursementButton
        proposalId={item.proposalId}
        refNo={item.refNo}
        canConfirm={item.canConfirmDisbursement}
      />
      <PcmpHoldActionButtons
        proposalId={item.proposalId}
        refNo={item.refNo}
        canHold={item.canHold}
        canRelease={item.canRelease}
        hold={item.hold}
        className="flex-nowrap"
      />
      <Link
        to="/pcmp/proposals/$proposalId"
        params={{ proposalId: item.proposalId }}
        className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1.5')}
      >
        <Eye className="size-3.5" />
        View
      </Link>
    </>
  );
}
